import { DataRoomShareableLink } from 'models/ShareableLink';

export type ShareableTable = Pick<
  DataRoomShareableLink,
  | 'name'
  | 'accessNumber'
  | 'fileIds'
  | 'lastAccessDate'
  | 'createdAt'
  | 'linkAccess'
  | 'linkExpiresDate'
>;

export type ShareableTableKeys = Array<keyof ShareableTable>;

export const TABLE_COLUMNS: ShareableTableKeys = [
  'name',
  'accessNumber',
  'fileIds',
  'lastAccessDate',
  'createdAt',
  'linkExpiresDate',
  'linkAccess',
];

export const HEADING_TRANSLATIONS: Record<
  typeof TABLE_COLUMNS[number],
  string
> = {
  name: 'a-z',
  accessNumber: 'access',
  fileIds: 'files',
  lastAccessDate: 'lastAccess',
  createdAt: 'created',
  linkExpiresDate: 'expiresOn',
  linkAccess: '',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  name: 350,
  accessNumber: 360,
  lastAccessDate: 160,
  createdAt: 160,
  linkExpiresDate: 160,
  fileIds: 80,
  linkAccess: 100,
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  name: 'sortName',
  lastAccessDate: 'lastAccessDate',
  createdAt: 'createdAt',
  linkExpiresDate: 'linkExpiresDate',
};
